var TimeZoneFormatType = /*#__PURE__*/function (TimeZoneFormatType) {
  TimeZoneFormatType["NAME"] = "name";
  TimeZoneFormatType["OFFSET"] = "offset";
  return TimeZoneFormatType;
}(TimeZoneFormatType || {});
const getTimezoneNameOrOffset = _ref => {
  var _formatter$formatToPa;
  let {
    timezone,
    language,
    formatType
  } = _ref;
  const formatter = new Intl.DateTimeFormat(language, {
    timeZone: timezone,
    timeZoneName: formatType === TimeZoneFormatType.NAME ? 'long' : 'short'
  });
  return (_formatter$formatToPa = formatter.formatToParts(new Date()).find(_ref2 => {
    let {
      type
    } = _ref2;
    return type === 'timeZoneName';
  })) == null ? void 0 : _formatter$formatToPa.value;
};
export const formatTimezone = _ref3 => {
  let {
    timezone,
    language
  } = _ref3;
  const timezoneName = getTimezoneNameOrOffset({
    timezone,
    language,
    formatType: TimeZoneFormatType.NAME
  });
  const timezoneOffset = getTimezoneNameOrOffset({
    timezone,
    language,
    formatType: TimeZoneFormatType.OFFSET
  });
  return `${timezoneName} (${timezoneOffset})`;
};
export const isSameDay = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
export const getDateRange = (date, range) => {
  const fromDate = new Date(date);
  fromDate.setDate(date.getDate() - range);
  const toDate = new Date(date);
  toDate.setDate(date.getDate() + range);
  return {
    fromDate,
    toDate
  };
};
//# sourceMappingURL=format-timezone.js.map